import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { serializeFilters } from '@user/components/Filters'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { DraftLeadFilterSet } from '../filters'
import { setDraftLeadFilters } from '../slice'
import { DraftLead } from '../typings'

export const useSaveDraftLeadFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)
  const draftPref = useMemo(
    () => prefs.find((p) => p.type === 'draft'),
    [prefs],
  )

  return useCallback(
    (model: DraftLeadFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: draftPref?.id,
          type: 'draft',
          name: 'draft filters',
          filter: serializeFilters<DraftLead, DraftLeadFilterSet>(model),
        }),
      )
      dispatch(setDraftLeadFilters(model))
    },
    [dispatch, draftPref?.id],
  )
}
